import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24">
    <title></title>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 18h14M5 14h14l1-9l-4 3l-4-5l-4 5l-4-3z"
    />
  </svg>
);

const CrownIcon = (props) => <Icon component={SVG} {...props} />;

export default CrownIcon;
